export default __webpack_public_path__ + "static/media/771.1a672170.png";